module.exports = __webpack_public_path__ + "img/cart_icon.23445736.svg";